import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	AccountReportAdditionalData,
	AccountReportRegistryFilters,
	AccountReportWithId,
	createAccountReportRegistryQuery,
} from 'shared/api';
import {
	createDateFilterModel,
	createRegistryModel,
	DateFilterModel,
	getToday,
	RegistryCallbacks,
	RegistryModel,
} from 'shared/lib';

export type AccountReportRegistryModel = {
	model: RegistryModel<
		AccountReportWithId,
		AccountReportRegistryFilters,
		JsonApiRequestError,
		AccountReportAdditionalData
	>;
	dateFilterModel: DateFilterModel;
	$total: Store<AccountReportAdditionalData['summary'] | null>;
};

export type CreateAccountReportRegistryModelParams = RegistryCallbacks;

export const createAccountReportRegistryModel = (
	params: CreateAccountReportRegistryModelParams,
): AccountReportRegistryModel => {
	const query = createAccountReportRegistryQuery();

	const [todayDate, currentTimeZone] = getToday();

	const model = createRegistryModel<
		AccountReportWithId,
		AccountReportRegistryFilters,
		JsonApiRequestError,
		AccountReportAdditionalData
	>({
		query,
		filters: {
			currencies: [],
			accountIds: [],
			dateTo: todayDate,
			dateFrom: todayDate,
			timeZone: currentTimeZone,
		},
		sortField: 'name',
		...params,
	});

	const $total = model.$additionalData.map((data) => data?.summary ?? null);

	const dateFilterModel = createDateFilterModel({
		fromChange: model.filters.dateFrom.setValue,
		toChange: model.filters.dateTo.setValue,
	});

	return { model, dateFilterModel, $total };
};
